import './style.scss';

import { EyeOutlined } from '@ant-design/icons';
import { Modal } from '@components/common/Modal/Modal';
import { PageTitle } from '@components/common/PageTitle/PageTitle';
import { PagingType, UTable } from '@components/common/UTable/UTable';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import {
  useGetDictionaryQuery,
  usePersistMedicineDictionaryMutation,
} from '@/api/dictionaries/api';
import { createModalConfig } from '@/pages/Pharmacy/components/modal.config';
import { Sort } from '@/shared/api/types';
import { OrganizationLevelType } from '@/shared/organizations/enums';
import { pharmacy } from '@/shared/security/permissions/pharmacy';
import { mapTableIndexWithPage } from '@/utils/utils';

import { columns } from './columns.config';

export const PharmacyDictionaries = () => {
  const [paging, setPaging] = useState<PagingType>({ page: 0, size: 10 });
  const [sort, setSort] = useState<Sort[] | undefined>(undefined);

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orgId = searchParams.get('organizationId') || '';

  const { data, isLoading } = useGetDictionaryQuery({
    dictionaryName: 'drug',
    pageable: paging,
    sort,
  });
  const { data: drugsTypes, isLoading: isDrugsTypesLoading } = useGetDictionaryQuery({
    dictionaryName: 'drugType',
  });

  const [saveDrug, { isLoading: isDrugLoading, isSuccess: isDrugSaveSuccess }] =
    usePersistMedicineDictionaryMutation();

  useEffect(() => {
    if (isDrugSaveSuccess) {
      setIsCreateModalOpen(false);
    }
  }, [isDrugSaveSuccess]);

  const onDrugCreate = async (payload: any) => {
    await saveDrug({ ...payload, organizationId: orgId });
  };
  const onSortChange = (sort?: Sort[]) => {
    setSort(sort);
  };

  return (
    <>
      <Modal
        mode={'form'}
        schema={createModalConfig(drugsTypes)}
        title={'Добавить препарат'}
        open={isCreateModalOpen}
        onSubmit={onDrugCreate}
        onCancel={() => {
          setIsCreateModalOpen(false);
        }}
        layout={{ formLayout: 'vertical', itemLayout: 'vertical' }}
        formKey={'createForm'}
        confirmLoading={isDrugLoading}
        destroyOnHidden={true}
      />
      <PageTitle title={'Справочник ветеринарных препаратов'} />
      <UTable
        size={'small'}
        data={mapTableIndexWithPage(data?.content, paging)}
        columns={columns(drugsTypes)}
        loading={isLoading || isDrugsTypesLoading}
        paging={paging}
        onPagingChange={setPaging}
        total={data?.totalElements}
        onChange={onSortChange}
        currentSort={sort}
        buttons={[
          {
            addBtn: true,
            action: () => setIsCreateModalOpen(true),
            security: {
              permissions: pharmacy.dictionary.addDrug,
              level: OrganizationLevelType.DISTRICT,
            },
          },
        ]}
        actions={() => [
          {
            icon: <EyeOutlined />,
            action: (record) => {
              navigate(`/pharmacy/dictionaries/${record?.id}`);
            },
            security: { permissions: pharmacy.dictionary.viewDrug },
          },
        ]}
      />
    </>
  );
};
